import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 border-t border-background-800">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              <span className="text-primary-500">🌸 春夜影院</span>
            </h4>
            <p className="text-foreground-500 text-sm leading-relaxed max-w-md">
              春夜影院提供免费高清电影电视剧在线观看，蓝光画质流畅播放不缓冲。最新电影、热门综艺、经典动漫，随时随地享受影院级观影体验。手机版、电脑版均可流畅访问。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-300 font-semibold text-sm mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/all" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">电影分类</Link></li>
              <li><Link to="/category/tvseries" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">电视剧</Link></li>
              <li><Link to="/category/variety" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">综艺节目</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-300 font-semibold text-sm mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">联系我们</Link></li>
              <li><a href="#" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer">隐私政策</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-600 text-xs">
            &copy; {currentYear} 春夜影院 ChunYeMovie.com - 免费高清在线影院
          </p>
          <p className="text-foreground-700 text-xs">
            本站所有资源均来自网络，仅供交流学习使用
          </p>
        </div>
      </div>
    </footer>
  );
}